import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CorsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiRegex = /aitarget\.(com|tech)\/api\//;

    const request = req.url.match(apiRegex) ? req.clone({ withCredentials: true }) : req;
    return next.handle(request);
  }
}
